<template>
  <div ref="layout" class="page-form">
    <h3 class="title">客户信息</h3>

    <div class="container">
      <div class="tools" style="margin-bottom: 10px">
        <form-button name="返回" @click="$router.go(-1)" />
      </div>
      <template v-if="clientData !== null">
        <base-info ref="info" :client-data="clientData">
          <template #role>
            <role ref="role" :role="clientData.ROLES" />
          </template>
          <template #relation>
            <client-relation ref="relation" :relation="clientData.RELATION" />
          </template>
          <template #bank>
            <bank-info ref="bank" :bank="clientData.BANK" />
          </template>
        </base-info>
      </template>
    </div>
  </div>
</template>
<script>
import BaseInfo from './BaseInfoCheck.vue'
import Role from './RoleCheck.vue'
import ClientRelation from './ClientRelationCheck.vue'
import BankInfo from './BankInfoCheck.vue'
// import { apiFindCustomerApprove } from '@/api/client'

import { getClientDetail } from '@/api/sap/client-sap'
export default {
  name: 'ClientEdit',
  components: { BaseInfo, Role, ClientRelation, BankInfo },
  data() {
    return {
      PARTNER: '',
      loading: true,
      clientData: null
    }
  },
  created() {
    this.PARTNER = this.$route.query.code
    this.getInfo()
  },
  methods: {
    async getInfo() {
      this.loading = true

      try {
        const { DATA } = await getClientDetail({ PARTNER: this.PARTNER })
        // const approve = await apiFindCustomerApprove({ customerCode: this.PARTNER })
        this.clientData = DATA
        // this.clientData.approve = approve?.data || {}
      } catch (e) {
        //
        this.clientData = {}
      }

      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  padding: 0 48px;
}
</style>



// WEBPACK FOOTER //
// src/views/client-manage/components/clientCheck.vue